module.exports = __webpack_public_path__ + "static/media/cesur.b8dda467.jpg";